import React from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip } from '@mui/material';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { useTheme } from '@mui/system';
import { setJustSelectedTab } from '#action/shipment/form';
import {
  IconBtn,
  MultipleArrowCtn,
  swapArrowStyle,
  singleArrowStyle,
  lastArrowStyle,
  disabledStyle
} from '#component/shipment/form/delivery/timeline/style';

const ArrowNext = ({
  handleSwapCheckpoints,
  currentIndex,
  isSingle = true,
  disabled
}) => {
  const theme = useTheme();
  const iconBtnStyle = {
    ...(isSingle && singleArrowStyle),
    ...(disabled && disabledStyle)
  };

  return (
    <IconBtn
      size="small"
      style={iconBtnStyle}
    >
      <Tooltip title="Move the checkpoint to next step">
        <ArrowDropDownRoundedIcon
          style={{
            ...swapArrowStyle(theme),
            ...(disabled && disabledStyle)
          }}
          onClick={() => handleSwapCheckpoints(currentIndex, currentIndex + 1)}
        />
      </Tooltip>
    </IconBtn>
  );
};

const ArrowPrev = ({
  handleSwapCheckpoints,
  currentIndex,
  isSingle = true,
  isLastIndex,
  disabled
}) => {
  const theme = useTheme();
  const iconBtnStyle = {
    ...(isSingle && singleArrowStyle),
    ...(disabled && disabledStyle),
    ...(isLastIndex && lastArrowStyle)
  };

  return (
    <IconBtn
      size="small"
      style={iconBtnStyle}
    >
      <Tooltip title="Move the checkpoint to previous step">
        <ArrowDropUpRoundedIcon
          style={{
            ...swapArrowStyle(theme),
            ...(disabled && disabledStyle)
          }}
          onClick={() => handleSwapCheckpoints(currentIndex, currentIndex - 1)}
        />
      </Tooltip>
    </IconBtn>
  );
};

const TimelineSwapArrows = ({
  currentIndex,
  lastIndex,
  disabled,
  fields,
  displayFields,
  setDisplayFields
}) => {
  const dispatch = useDispatch();

  const handleSwapCheckpoints = (from, to) => {
    const swapObjects = (array, index1, index2) => {
      const newArray = [...array];
      [newArray[index1], newArray[index2]] = [newArray[index2], newArray[index1]];

      return newArray;
    };

    const swappedArray = swapObjects(displayFields, from, to);

    dispatch(setJustSelectedTab(true));

    setTimeout(() => {
      dispatch(setJustSelectedTab(false));
    }, 2000);

    fields.swap(from, to);
    setDisplayFields(swappedArray);
  };

  if (lastIndex === 0) {
    return null;
  }

  if (currentIndex === 0) {
    return <ArrowNext
      handleSwapCheckpoints={handleSwapCheckpoints}
      currentIndex={currentIndex}
      disabled={disabled}
    />;
  }

  if (currentIndex === lastIndex) {
    return <ArrowPrev
      handleSwapCheckpoints={handleSwapCheckpoints}
      currentIndex={currentIndex}
      disabled={disabled}
      isLastIndex={true}
    />;
  }

  return (
    <MultipleArrowCtn>
      <ArrowPrev
        handleSwapCheckpoints={handleSwapCheckpoints}
        currentIndex={currentIndex}
        disabled={disabled}
        isSingle={false}
      />
      <ArrowNext
        handleSwapCheckpoints={handleSwapCheckpoints}
        currentIndex={currentIndex}
        disabled={disabled}
        isSingle={false}
      />
    </MultipleArrowCtn>
  );
};

export default TimelineSwapArrows;
